module.exports = __webpack_public_path__ + "fonts/SetoFont-1.e8f777a7.ttf";